<template>
    <div class="bg-white shadow overflow-hidden sm:rounded-lg">
        <div>
            <dl>
                <slot></slot>
            </dl>
        </div>
    </div>
</template>
